// Magnetic buttons: primary and secondary buttons lean a few pixels toward the cursor, then settle back.
// Fine pointers only, and only when motion is allowed. Writes --mx/--my on the hovered button.
class SMagnetic extends HTMLElement {
  #controller = null;
  #frame = 0;
  #active = null;

  connectedCallback() {
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduce || this.#controller) return;
    this.#controller = new AbortController();
    const strength = Number(this.getAttribute('strength')) || 0.25;
    const max = 8;

    document.addEventListener('pointermove', (event) => {
      const target = event.target instanceof Element ? event.target.closest('.button-primary, .button-secondary') : null;
      if (this.#active && this.#active !== target) this.#release(this.#active);
      if (!target) return;
      this.#active = target;
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => {
        const rect = target.getBoundingClientRect();
        const x = (event.clientX - (rect.left + rect.width / 2)) * strength;
        const y = (event.clientY - (rect.top + rect.height / 2)) * strength;
        target.style.setProperty('--mx', `${Math.max(-max, Math.min(max, x))}px`);
        target.style.setProperty('--my', `${Math.max(-max, Math.min(max, y))}px`);
      });
    }, { passive: true, signal: this.#controller.signal });

    document.addEventListener('pointerleave', () => this.#active && this.#release(this.#active), { signal: this.#controller.signal });
  }

  #release(button) {
    button.style.removeProperty('--mx');
    button.style.removeProperty('--my');
    if (this.#active === button) this.#active = null;
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
    cancelAnimationFrame(this.#frame);
  }
}

if (!customElements.get('s-magnetic')) customElements.define('s-magnetic', SMagnetic);
